import type { ComponentType } from 'react';
import {
  Icon28CakeOutline, Icon28CameraOutline, Icon28CarOutline, Icon28FavoriteOutline,
  Icon28GiftOutline, Icon28HeartCircleOutline, Icon28HomeOutline, Icon28MagicWandOutline,
  Icon28MusicOutline, Icon28PlaceOutline, Icon28ServicesOutline, Icon28StarsOutline,
} from '@vkontakte/icons';

type IconProps = { width?: number; height?: number };

const CAT_ICONS: Record<number, ComponentType<IconProps>> = {
  1: Icon28StarsOutline,
  2: Icon28MagicWandOutline,
  3: Icon28MusicOutline,
  4: Icon28HeartCircleOutline,
  5: Icon28GiftOutline,
  6: Icon28FavoriteOutline,
  7: Icon28CameraOutline,
  8: Icon28PlaceOutline,
  9: Icon28CakeOutline,
  10: Icon28CarOutline,
  11: Icon28HomeOutline,
};

const CAT_TONES = ['blue', 'violet', 'rose', 'sand', 'mint', 'sky', 'peach', 'pink', 'lilac', 'aqua'] as const;

export const CAT_ICON_IDS = Object.keys(CAT_ICONS).map(Number);

export function catTone(iconId?: number | null): string {
  if (!iconId || !CAT_ICONS[iconId]) return 'gray';
  return CAT_TONES[(iconId - 1) % CAT_TONES.length];
}

export function CatBadge({ iconId, size = 28 }: { iconId?: number | null; size?: number }) {
  const Icon = (iconId && CAT_ICONS[iconId]) || Icon28ServicesOutline;
  const sm = size <= 20;
  return (
    <span
      className={`colibri-cat-badge colibri-cat-badge--${catTone(iconId)}${sm ? ' colibri-cat-badge--sm' : ''}`}
      style={sm ? undefined : { width: size, height: size }}
      aria-hidden="true"
    >
      <Icon width={sm ? 14 : 18} height={sm ? 14 : 18} />
    </span>
  );
}
